import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as FinanceApi from '@vwd/finance-api-client';
import { TranslateService } from '@ngx-translate/core';

// const session = {
//   moduleDirectoryName: 'VWD_TERMINAL',
//   customerId: 12034,
//   vwdUserId: 460054,
// };

const apikey = 'dev.vwd-webtech.com';

@Injectable()
export class AppService {

  private financeApi;

  constructor(private http: HttpClient, private translate: TranslateService) {
    translate.setDefaultLang('de');
    translate.use('de');
  }

  initializeApp(): Promise<any> {
    return new Promise((resolve, reject) => {

      //http://localhost:4100/?moduleName=VWD_TERMINAL&customerId=12034&vwdId=460054&instrumentId=7433336

      const url = new URL(window.location.href);
      const moduleName = url.searchParams.get('moduleName');
      const customerId = parseInt(url.searchParams.get('customerId'));
      const vwdId = parseInt(url.searchParams.get('vwdId'));

      let config = {};

      if (moduleName && customerId && vwdId) {
        config = {
          moduleDirectoryName: moduleName,
          customerId,
          vwdUserId: vwdId
        };
      }

      this.createApiInstance(config).then(() => {
        this.translate.setDefaultLang('de');
        this.translate.use('de');
        resolve();
      });
    });
  }

  // getSettings(): Promise<any> {
  //   const promise = this.http.get('./assets/configs/customer-config.json')
  //     .toPromise()
  //     .then(conf => {
  //       return conf;
  //     });
  //   return promise;
  // }

  public async createApiInstance(config) {
    this.financeApi = await new FinanceApi(config, apikey).
      catch((err: Error) => { console.error('[ERROR] JSAPI:', err); });
  }

  public getInstance() {
    return this.financeApi;
  }
}


